<p-toast position="bottom-center"></p-toast>

<div class="card md-form-shell">
  <form
    [formGroup]="branchForm"
    (ngSubmit)="saveBranch()"
    novalidate
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="off"
  >
    <div class="card-container bg-gray-100 border-round mt-2 p-4">
      <div class="mr-5 flex align-items-center mb-3">
        <i class="pi pi-file-edit mr-2 text-3xl"></i>
        <div class="font-medium text-3xl text-900">{{ pageTitle }}</div>
      </div>

      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-sitemap"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                id="branchName"
                type="text"
                pInputText
                formControlName="name"
                class="w-full"
                placeholder="Enter branch name"
              />
              <label for="branchName">Branch Name</label>
            </p-iftalabel>
          </p-inputgroup>
          <small *ngIf="branchForm.get('name')?.invalid && branchForm.get('name')?.touched" class="p-error">
            Branch Name is required.
          </small>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                id="branchCode"
                type="text"
                pInputText
                formControlName="code"
                class="w-full"
                placeholder="Enter branch code"
              />
              <label for="branchCode">Branch Code</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-wallet"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                id="arAccount"
                type="text"
                pInputText
                formControlName="arAccount"
                class="w-full"
                placeholder="Enter AR account"
              />
              <label for="arAccount">AR Account</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-wallet"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                id="apAccount"
                type="text"
                pInputText
                formControlName="apAccount"
                class="w-full"
                placeholder="Enter AP account"
              />
              <label for="apAccount">AP Account</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-align-left"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                id="reference"
                type="text"
                pInputText
                formControlName="reference"
                class="w-full"
                placeholder="Enter reference"
              />
              <label for="reference">Reference</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      </div>
    </div>

    <div class="mt-4 flex justify-content-end gap-2">
      <p-button
        label="Cancel"
        styleClass="p-button-secondary"
        type="button"
        (onClick)="cancel()"
      ></p-button>
      <p-button
        [label]="isEditMode ? 'Update Branch' : 'Save Branch'"
        type="submit"
        [disabled]="branchForm.invalid"
      ></p-button>
    </div>
  </form>
</div>
